import _isEqual from "lodash/isEqual";
import { useState, useEffect } from "react";
function useStateWithDep(defaultValue) {
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    if (defaultValue && !_isEqual(defaultValue, value)) {
      setValue(defaultValue);
    }
  }, [defaultValue]);
  return [value, setValue];
}
export {
  useStateWithDep
};
//# sourceMappingURL=useStateWithDep.js.map
